import type { RovoApp } from '@atlassian/conversation-assistant-chat-prompt-input/controllers/chat-mode-store/types';
import { useChatModeStoreActions as useChatModeStoreActionsRefresh } from '@atlassian/conversation-assistant-chat-prompt-input/useChatModeStoreActions';

export const useOnNewConversationStartedWithSendMessage = () => {
	const { setChatMode } = useChatModeStoreActionsRefresh();

	return (
		newConversationId: string,
		mode: {
			deepResearchEnabled?: boolean;
			thinkDeeperEnabled?: boolean;
			alphaExtendedThinkingMode?: 'MARATHON' | 'LONG_HORIZON';
			fastModeEnabled?: boolean;
			planModeEnabled?: boolean;
			webSearchEnabled?: boolean;
			useCurrentPageContext?: boolean;
			appFilters?: RovoApp[];
		},
	): void => {
		setChatMode(newConversationId, {
			// TODO: ROVOFE-1411 - refactor into passing the reasoningMode directly
			reasoningMode: mode.deepResearchEnabled
				? 'deep-research'
				: mode.thinkDeeperEnabled
					? mode.alphaExtendedThinkingMode === 'LONG_HORIZON'
						? 'think-deeper-orchestrator'
						: mode.alphaExtendedThinkingMode === 'MARATHON'
							? 'think-deeper-marathon'
							: 'think-deeper'
					: mode.planModeEnabled
						? 'task'
						: mode.fastModeEnabled
							? 'fast'
							: 'auto',
			webSearchEnabled: mode.webSearchEnabled ?? false,
			useCurrentPageContext: mode.useCurrentPageContext ?? false,
			appFilters: mode.appFilters,
		});
	};
};
